import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";

import { enqueueSnackbar } from "notistack";

const updateEventShow = async (vendor, user, show, eventId, logout) => {
  const storageAvailable = localStorageAvailable();
  const accessToken = storageAvailable
    ? localStorage.getItem("accessToken")
    : "";
  const config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `/service/events_service/v1/events/event/show_in_list/${eventId}`,
    headers: {
      authorization: `Bearer ${accessToken}`,
      user,
      timestamp: new Date(),
      vendor,
    },
    data: { show_in_list: show },
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    if (error?.data === "Verification timeout") {
      return;
    }
    if (error?.status === 401) {
      enqueueSnackbar("Un Authorized Request", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      logout();
    }
    enqueueSnackbar(error?.data?.message || error?.data || error, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  }
};

export default updateEventShow;
